import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('calendar-dropdown',{model:{value:(_vm.dob),callback:function ($$v) {_vm.dob=$$v},expression:"dob"}},[_c(VTextField,_vm._b({attrs:{"label":_vm.$t('Date of birth'),"outlined":"","readonly":"","hide-details":"auto"},model:{value:(_vm.dob),callback:function ($$v) {_vm.dob=$$v},expression:"dob"}},'v-text-field',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }